// Copyright (c) 2017 Deere & Company

import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import InvoiceClaimsProcess, {getDefaultState as getInvoiceClaimsProcessDefaultState} from './invoice-claims-process';
import InvoiceMassProcess from './invoice-mass-process';
import t from 'tcomb';

const Invoice = t.struct({
    claimsProcess: t.maybe(InvoiceClaimsProcess),
    dealer: Dealer,
    dealerAccount: t.String,
    id: t.String,
    invoiceId: t.String,
    isMassProcessing: t.Bool,
    massProcess: t.maybe(InvoiceMassProcess)
}, {
    name: 'Invoice',
    strict: true
});

export const getDefaultState = () => new Invoice({
    claimsProcess: getInvoiceClaimsProcessDefaultState(),
    dealer: getDealerDefaultState(),
    dealerAccount: '',
    id: '',
    invoiceId: '',
    isMassProcessing: false,
    massProcess: null
});

Invoice.prototype.sortByDate = function sortByDate() {

    return this.isMassProcessing ? this.massProcess.requestDate : this.claimsProcess.waitingForDealerInvoiceSince;

};

export default Invoice;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/invoice.js